// src/common/PromptDialog.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { Button, DialogActions, DialogContent, TextField } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import DraggableEditor from './DraggableEditor';
import { AppStyle, AppWord } from '../value/AppConst';

export default function PromptDialog({
    open,
    title,
    message,
    defaultValue,
    isEdit,
    onClose,
    onSubmit
}) {
    const [inputValue, setInputValue] = useState('');
    const [changed, setChanged] = useState(false);
    const [askCancel, setAskCancel] = useState(false);

    useEffect(()=>{
        if(open) {
            setInputValue(defaultValue || '');
            setChanged(false);
        }
    }, [open, defaultValue]);

    const onClickSubmit = () => {
        onSubmit(inputValue, isEdit); // regardless of content of inputValue
    };

    const onChangeInput = (e) => {
        setInputValue(e.target.value);
        setChanged(true);
    };

    const onClickCancel = async () => {
        if(changed) {
            setAskCancel(true);
        } else {
            onClose();
        }
    };

    return(
        <DraggableEditor open={open} maxWidth='lg'
            onClose={onClickCancel}
            startIcon={<CreateIcon size={AppWord.LARGE} />}
            title={title}
        >
            <DialogContent>
                <Box style={{
                    margin: '16px 10px',
                    minWidth: 600,
                    color: askCancel ? '#d32f2f' : 'inherit',
                    fontWeight: askCancel ? 'bold' : 'inherit'}}
                >
                    {
                        askCancel
                        ?
                        ' 변경사항이 있습니다. 정말 취소하시겠습니까?'
                        :
                        (message || '데이터를 입력하세요')
                    }
                </Box>
                <Box style={{margin: '0px 10px'}}>
                    <TextField
                        fullWidth
                        value={inputValue}
                        onChange={onChangeInput}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                {
                    askCancel
                    ?
                    <Button
                        onClick={() => {
                            setAskCancel(false);
                            onClose();
                        }}
                        color={AppStyle.mui.warning}
                        variant={AppStyle.mui.contained}
                        startIcon={<CloseIcon />}
                    >
                        변경사항 무시하고 취소
                    </Button>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={!changed}
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                            startIcon={<DoneIcon />}
                        >저장</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                            startIcon={<CloseIcon />}
                        >취소</Button>
                    </>
                }
            </DialogActions>
        </DraggableEditor>
    );
}